// extracted by mini-css-extract-plugin
export default {"container":"App_container__4L7Vo","sections":"App_sections__viBNJ"};